import { ILegalEntityAuditClassificationReportDialogProps } from "./LegalEntityAuditClassificationReportDialog.tsx";
import { useState } from "react";
import { useUrlProvider } from "../../../useUrlProvider.ts";
import { BaseViewModel } from "../../../system/systemOverview/SystemOverview.types.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalEntityAuditClassificationReportDialog(props: ILegalEntityAuditClassificationReportDialogProps) {
    const { getLegalEntityRiskAuditReportUrl, getLegalEntityRiskClassificationReportUrl } = useUrlProvider();
    const [selectedItem, setSelectedItem] = useState<string | null>(null);
    const url = (props.type === "classification" ? "/LegalEntityRiskClassificationReport" : "/LegalEntityRiskAuditReport") + `?scope=${props.scope}`;

    const { data, isLoading } = useDotLegalQuery<Array<BaseViewModel>>(url);

    function openReport() {
        if (!selectedItem) return;
        const url =
            props.type === "classification"
                ? getLegalEntityRiskClassificationReportUrl(selectedItem, props.scope)
                : getLegalEntityRiskAuditReportUrl(selectedItem, props.scope);
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
        props.onClose();
    }

    return { selectedItem, setSelectedItem, openReport, options: data, isLoading };
}
